// import React, {useState, useEffect} from 'react';
// import {List, ListItem, ListItemText, Divider} from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Tareas = props => {
//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const [gestionTareas, setGestionTareas] = useState (false);
//   const [misTareas, setMisTareas] = useState(false);
//   const [asignarTareas, setAsignarTareas] = useState(false);
//   const [panelTareas, setPanelTareas] = useState(false);

//   const [openGestionTareas, setOpenGestionTareas] = useState (false);
//   const handleOpenGestionTareas = () => {
//     setOpenGestionTareas (!openGestionTareas);
//   };

//   const VerificarPermisos = arrPermisos => {
//     setGestionTareas (EvaluarPermiso (arrPermisos, '/gestionTareas'));
//     setMisTareas (EvaluarPermiso (arrPermisos, '/tareasPrincipal'));
//     setAsignarTareas (EvaluarPermiso (arrPermisos, '/asignarTareas'));
//     setPanelTareas (EvaluarPermiso (arrPermisos, '/panelTareas'));
//   };

//   return (
//     <React.Fragment>
//       {gestionTareas
//         ? <List>
//             <ListItem onClick={handleOpenGestionTareas}>
//               <i notranslate="true" className="material-icons">
//                 pending_actions
//               </i>
//               <ListItemText
//                 classes={{primary: classes.listItemText}}
//                 primary="Gestión de Tareas"
//               />
//               {openGestionTareas ? <ExpandLess /> : <ExpandMore />}
//             </ListItem>
//             <Collapse in={openGestionTareas} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 {misTareas
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/tareasPrincipal"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         content_paste
//                       </i>
//                       <ListItemText primary="Mis Tareas" />
//                     </ListItem>
//                   : null}
//                 <div>
//                   {asignarTareas
//                     ? <ListItem
//                         component={Link}
//                         button
//                         to="/asignarTareas"
//                         className={classes.listItemText}
//                       >
//                         <i notranslate="true" className="material-icons">
//                           assignment_ind
//                         </i>
//                         <ListItemText primary="Asignar Tareas" />
//                       </ListItem>
//                     : null}
//                   {panelTareas
//                     ? <ListItem
//                         component={Link}
//                         button
//                         to="/panelTareas"
//                         className={classes.listItemText}
//                       >
//                         <i notranslate="true" className="material-icons">
//                           screen_share
//                         </i>
//                         <ListItemText primary="Panel de Tareas" />
//                       </ListItem>
//                     : null}
//                 </div>
//               </List>
//             </Collapse>
//           </List>
//         : null}

//       {gestionTareas ? <Divider /> : null}
//     </React.Fragment>
//   );
// };

// export default Tareas;
import React, { useState, useEffect } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Tareas = ({ sesionUsuario }) => {
  const [gestionTareas, setGestionTareas] = useState(false);
  const [misTareas, setMisTareas] = useState(false);
  const [asignarTareas, setAsignarTareas] = useState(false);
  const [panelTareas, setPanelTareas] = useState(false);

  const [openGestionTareas, setOpenGestionTareas] = useState(false);
  const handleOpenGestionTareas = () =>
    setOpenGestionTareas(!openGestionTareas);

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setGestionTareas(EvaluarPermiso(permisos, '/gestionTareas'));
    setMisTareas(EvaluarPermiso(permisos, '/tareasPrincipal'));
    setAsignarTareas(EvaluarPermiso(permisos, '/asignarTareas'));
    setPanelTareas(EvaluarPermiso(permisos, '/panelTareas'));
  }, [sesionUsuario]);

  return (
    <>
      {gestionTareas && (
        <>
          <ListItem
            button
            onClick={handleOpenGestionTareas}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <PendingActionsIcon />
            </ListItemIcon>
            <ListItemText
              primary="Gestión de Tareas"
              sx={menuItemStyles.menuText}
            />
            {openGestionTareas ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openGestionTareas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {misTareas && (
                <ListItem
                  button
                  component={Link}
                  to="/tareasPrincipal"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ContentPasteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Mis Tareas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {asignarTareas && (
                <ListItem
                  button
                  component={Link}
                  to="/asignarTareas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AssignmentIndIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Asignar Tareas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {panelTareas && (
                <ListItem
                  button
                  component={Link}
                  to="/panelTareas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <ScreenShareIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Panel de Tareas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Tareas;
